// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as FormattedDateTimeShort from "../FormattedDataTime/FormattedDateTimeShort.bs.jsx";
import TableConsumptionsModuleCss from "./TableConsumptions.module.css";

let classes = TableConsumptionsModuleCss;

function TableConsumptions(props) {
  let onDeleteConsumption = props.onDeleteConsumption;
  let formatConsumption = props.formatConsumption;
  return <table
    aria-labelledby={props.ariaLabelledby}
    className={classes.table + ` ` + Styles.table.inDialog}
  >
    <thead>
      <tr
        className={Styles.utility.srOnly}
      >
        <th
          scope={"col"}
        >
          {"Pivo"}
        </th>
        <th
          scope={"col"}
        >
          {"Kdy"}
        </th>
        <th
          scope={"col"}
        >
          {"Objem"}
        </th>
        <th
          scope={"col"}
        >
          <span
            className={Styles.utility.srOnly}
          >
            {"Akce"}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      {props.unfinishedConsumptions.map(consumption => {
        let createdAt = consumption.createdAt.toISOString();
        return <tr
          key={createdAt} >
          <th
            scope={"row"}
          >
            {consumption.beer}
          </th>
          <td>
            <FormattedDateTimeShort.make
              value={consumption.createdAt}
            />
          </td>
          <td>
            {formatConsumption(consumption.milliliters)}
          </td>
          <td>
            <button
              className={classes.deleteButton + ` ` + Styles.button.sizeExtraSmall}
              type={"button"}
              onClick={param => onDeleteConsumption(consumption)}
            >
              {"🗑️ Smáznout"}
            </button>
          </td>
        </tr>;
      })}
    </tbody>
  </table>;
}

let make = TableConsumptions;

export {
  classes,
  make,
}
/* classes Not a pure module */
